module.exports = __webpack_public_path__ + "img/nowtitle.b418c60a.png";